import React, { useEffect } from "react";

import cn from "classnames";
import styles from "./Components.module.sass";

import { UseApi } from "../../../hooks/use-api";
import { GetPopular } from "../../../Services/lib/nft";
import { listGenerator } from "..";

const CustomizePopularProducts = () => {
	const [{ isLoading, data }, fetch] = UseApi({
		service: GetPopular,
	});

	useEffect(() => {
		fetch("4");
	}, []);
	return (
		<>
			{isLoading ? (
				<div className={styles.wrap}>
					{listGenerator(4).map((e, i) => {
						return (
							<div key={`_${i + 1}_`} className={styles.columnCon}>
								<div className={styles.busyContainer} />
								<div className={styles.line1} />
								<div className={styles.line2} />
							</div>
						);
					})}
				</div>
			) : (
				<div className={styles.ph}>
					<div className={cn(styles.pflex)}>
						{data?.list?.map((e, i) => {
							return <CCard key={`_card_${i}`} item={e} />;
						})}
					</div>
				</div>
			)}
			<br />
			<br />
		</>
	);
};

const CCard = ({ item }) => {
	return (
		<>
			<div className={styles.pcard}>
				<img src={item.image} className={styles.pImage} alt=" __image__" />
				<div className={styles.pName}>{item.name}</div>
				<div className={styles.exclusive}>EXCLUSIVE</div>
				<div className={styles.price}>$ {item.price}</div>
			</div>
		</>
	);
};
export default CustomizePopularProducts;
